var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M10 18.8333C14.6024 18.8333 18.3334 15.1023 18.3334 10.5C18.3334 5.89759 14.6024 2.16663 10 2.16663C5.39765 2.16663 1.66669 5.89759 1.66669 10.5C1.66669 15.1023 5.39765 18.8333 10 18.8333Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M7.91669 7.97107C7.91669 7.57333 7.91669 7.37446 7.99981 7.26344C8.07224 7.16669 8.18311 7.10616 8.30367 7.09755C8.44201 7.08766 8.60929 7.1952 8.94386 7.41028L12.8777 9.93917C13.168 10.1258 13.3132 10.2191 13.3633 10.3378C13.4071 10.4415 13.4071 10.5585 13.3633 10.6621C13.3132 10.7808 13.168 10.8741 12.8777 11.0607L8.94386 13.5896C8.60929 13.8047 8.44201 13.9123 8.30367 13.9024C8.18311 13.8938 8.07224 13.8332 7.99981 13.7365C7.91669 13.6255 7.91669 13.4266 7.91669 13.0288V7.97107Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "ccc864a3d6eb92fb5c2c4ce6529c68fe.svg";
export { ForwardRef as ReactComponent };